import { Component, OnInit } from '@angular/core';
import { ZkDevice, ZkUser } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ExcelexportService } from '../excelexport.service';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-zkteco',
  templateUrl: './zkteco.component.html',
  styleUrls: ['./zkteco.component.scss']
})
export class ZktecoComponent implements OnInit {

  dispositivos: ZkDevice[] = [];
  userSelect: ZkUser;
  usuarios: ZkUser[] = [];
  usuariosSearch: ZkUser[] = [];

  classListadoEmpleados = 'EmpleadosListBig';

  searchString = '';

  datosLoad: boolean = false;

  constructor(
    public rest: RestService,
    private excel: ExcelexportService,
    public user: UserService
  ) { }

  ngOnInit() { this.ObtenerUsuariosParking(); }

  exportAsXLSX(): void {
    this.rest.ObtenerDispositivosPorUsuario(this.userSelect.id).subscribe(
      (data) => {
        this.excel.exportZkUsers(data['data'], 'DATOS HORAS - ' + this.userSelect.name);
      },
      (error) => alert(error.error.data));
  }

  searchListEmpleados(){
    console.log(this.filterItems());
    
    this.usuarios = this.filterItems();
  }

  filterItems(){

    if ( this.searchString === ''){ return this.usuariosSearch; }

    return this.usuariosSearch.filter((item) => {
     return item.search.toLowerCase().indexOf(
      this.searchString.toLowerCase()) > -1;
     });
    }

  bigList(){
    this.classListadoEmpleados = 'EmpleadosListBig';
  }

  smallList(){
    this.classListadoEmpleados = 'EmpleadosListSmall';
  }

  ObtenerDispositivosPorUsuario(usuario){
    this.ActivateLoad();
    this.userSelect = usuario;
    this.rest.ObtenerDispositivosPorUsuario(usuario.id).subscribe(
      (data) => {
        this.dispositivos = data['data'];
        this.datosLoad = false;
      },
      (error) => alert(error.error.data));
  }

  ObtenerUsuariosParking(){
    this.ActivateLoad();
    this.rest.ObtenerUsuariosParking().subscribe(
      (data) => {
        this.usuarios = data['data'];
        this.usuariosSearch = data['data'];
        this.datosLoad = false;
      },
      (error) => alert(error.error.data));
  }

  AsignarPrioridad(device){

    Swal.fire({ title: 'Cargando', text: 'Espere por favor', icon: 'question' });
    Swal.showLoading();

    this.rest.AsignarPrioridad(device.priority,device.id,device.order).subscribe(
      (data) => {
        Swal.close();
        this.user.SuccessSwal('DATOS EMPLEADO POR DISPOSITIVO',data['data']);
      },
      (error) => {
        Swal.close();
        this.user.ErrorSwal(error);
      });
  }

  GuardarNombre(id,name){
    const opcion = confirm('¿Desea cambiar el nombre?');

    if ( opcion ){
      this.rest.GuardarNombre(id,name).subscribe(
        (data) => alert(data['data']),
        (error) => alert(error.error.data));
    }
    
  }

  ActivateLoad(){
    this.datosLoad = true;
    setTimeout(() => this.datosLoad = false, 15000);
  }


}
